// Generated by measuring the official PDF (see spec.mjs header). Top-down y.
export default {
 "_page_heights": [
  792.0,
  792.0,
  792.0
 ],
 "q1.yes": {
  "page": 0,
  "x": 500.1,
  "y": 298.2
 },
 "q1.no": {
  "page": 0,
  "x": 559.0,
  "y": 298.2
 },
 "q2.yes": {
  "page": 0,
  "x": 500.1,
  "y": 311.7
 },
 "q2.no": {
  "page": 0,
  "x": 559.0,
  "y": 311.7
 },
 "q3.yes": {
  "page": 0,
  "x": 500.1,
  "y": 325.1
 },
 "q3.no": {
  "page": 0,
  "x": 559.0,
  "y": 325.1
 },
 "q4.yes": {
  "page": 0,
  "x": 500.1,
  "y": 338.6
 },
 "q4.no": {
  "page": 0,
  "x": 559.0,
  "y": 338.6
 },
 "q5.yes": {
  "page": 0,
  "x": 500.1,
  "y": 352.0
 },
 "q5.no": {
  "page": 0,
  "x": 559.0,
  "y": 352.0
 },
 "q6.yes": {
  "page": 0,
  "x": 500.1,
  "y": 365.4
 },
 "q6.no": {
  "page": 0,
  "x": 559.0,
  "y": 365.4
 },
 "q7.yes": {
  "page": 0,
  "x": 500.1,
  "y": 378.8
 },
 "q7.no": {
  "page": 0,
  "x": 559.0,
  "y": 378.8
 },
 "q8.yes": {
  "page": 0,
  "x": 500.1,
  "y": 405.6
 },
 "q8.no": {
  "page": 0,
  "x": 559.0,
  "y": 405.6
 },
 "q9.yes": {
  "page": 0,
  "x": 500.1,
  "y": 419.1
 },
 "q9.no": {
  "page": 0,
  "x": 559.0,
  "y": 419.1
 },
 "q10.yes": {
  "page": 0,
  "x": 500.1,
  "y": 448.1
 },
 "q10.no": {
  "page": 0,
  "x": 559.0,
  "y": 448.1
 },
 "q11.yes": {
  "page": 0,
  "x": 500.1,
  "y": 503.7
 },
 "q11.no": {
  "page": 0,
  "x": 559.0,
  "y": 503.7
 },
 "q12.yes": {
  "page": 0,
  "x": 500.1,
  "y": 544.0
 },
 "q12.no": {
  "page": 0,
  "x": 559.0,
  "y": 544.0
 },
 "q13.yes": {
  "page": 0,
  "x": 500.1,
  "y": 570.8
 },
 "q13.no": {
  "page": 0,
  "x": 559.0,
  "y": 570.8
 },
 "q13a.yes": {
  "page": 0,
  "x": 500.1,
  "y": 611.2
 },
 "q13a.no": {
  "page": 0,
  "x": 559.0,
  "y": 611.2
 },
 "q13b.yes": {
  "page": 0,
  "x": 500.1,
  "y": 705.1
 },
 "q13b.no": {
  "page": 0,
  "x": 559.0,
  "y": 705.1
 },
 "q14.yes": {
  "page": 1,
  "x": 500.1,
  "y": 86.4
 },
 "q14.no": {
  "page": 1,
  "x": 559.0,
  "y": 86.4
 },
 "q15.yes": {
  "page": 1,
  "x": 500.1,
  "y": 210.9
 },
 "q15.no": {
  "page": 1,
  "x": 559.0,
  "y": 210.9
 },
 "q16.yes": {
  "page": 1,
  "x": 500.6,
  "y": 240.9
 },
 "q16.no": {
  "page": 1,
  "x": 559.0,
  "y": 240.9
 },
 "q16a.yes": {
  "page": 1,
  "x": 500.6,
  "y": 271.7
 },
 "q16a.no": {
  "page": 1,
  "x": 559.0,
  "y": 271.7
 },
 "q16b.yes": {
  "page": 1,
  "x": 500.6,
  "y": 287.2
 },
 "q16b.no": {
  "page": 1,
  "x": 559.0,
  "y": 287.2
 },
 "q17.yes": {
  "page": 1,
  "x": 500.6,
  "y": 318.1
 },
 "q17.no": {
  "page": 1,
  "x": 559.0,
  "y": 318.1
 },
 "q18.yes": {
  "page": 1,
  "x": 500.6,
  "y": 331.5
 },
 "q18.no": {
  "page": 1,
  "x": 559.0,
  "y": 331.5
 },
 "q19.yes": {
  "page": 1,
  "x": 500.6,
  "y": 358.4
 },
 "q19.no": {
  "page": 1,
  "x": 559.0,
  "y": 358.4
 },
 "q22.yes": {
  "page": 1,
  "x": 501.6,
  "y": 693.7
 },
 "q22.no": {
  "page": 1,
  "x": 560.0,
  "y": 693.7
 },
 "q25.yes": {
  "page": 2,
  "x": 501.6,
  "y": 132.8
 },
 "q25.no": {
  "page": 2,
  "x": 560.0,
  "y": 132.8
 },
 "q26.yes": {
  "page": 2,
  "x": 501.6,
  "y": 179.1
 },
 "q26.no": {
  "page": 2,
  "x": 560.0,
  "y": 179.1
 },
 "q27.yes": {
  "page": 2,
  "x": 501.6,
  "y": 240.9
 },
 "q27.no": {
  "page": 2,
  "x": 560.0,
  "y": 240.9
 },
 "q28.yes": {
  "page": 2,
  "x": 501.6,
  "y": 256.2
 },
 "q28.no": {
  "page": 2,
  "x": 560.0,
  "y": 256.2
 },
 "q29.yes": {
  "page": 2,
  "x": 501.6,
  "y": 283.1
 },
 "q29.no": {
  "page": 2,
  "x": 560.0,
  "y": 283.1
 },
 "q30.yes": {
  "page": 2,
  "x": 501.6,
  "y": 296.6
 },
 "q30.no": {
  "page": 2,
  "x": 560.0,
  "y": 296.6
 },
 "q30a.yes": {
  "page": 2,
  "x": 501.6,
  "y": 336.9
 },
 "q30a.no": {
  "page": 2,
  "x": 560.0,
  "y": 336.9
 },
 "q30b.yes": {
  "page": 2,
  "x": 501.6,
  "y": 363.6
 },
 "q30b.no": {
  "page": 2,
  "x": 560.0,
  "y": 363.6
 },
 "q9.detail": {
  "page": 0,
  "x": 197.3,
  "y": 434.6,
  "w": 251.9
 },
 "q16c.count": {
  "page": 1,
  "x": 321.5,
  "y": 298.6,
  "w": 125.9
 },
 "q18.date": {
  "page": 1,
  "x": 241.0,
  "y": 344.9,
  "w": 164.3
 },
 "q19a.when": {
  "page": 1,
  "x": 291.9,
  "y": 385.1,
  "w": 153.3
 },
 "q19b.gut": {
  "page": 1,
  "x": 349.2,
  "y": 398.6,
  "w": 98.5
 },
 "q19c.original_use": {
  "page": 1,
  "x": 347.6,
  "y": 412.0,
  "w": 98.6
 },
 "q20a.project": {
  "page": 1,
  "x": 305.9,
  "y": 438.9,
  "w": 27.5
 },
 "q20b.project": {
  "page": 1,
  "x": 305.9,
  "y": 454.4,
  "w": 27.5
 },
 "q20c.project": {
  "page": 1,
  "x": 305.9,
  "y": 477.6,
  "w": 27.5
 },
 "q20d.project": {
  "page": 1,
  "x": 305.9,
  "y": 506.4,
  "w": 27.5
 },
 "q20e.project": {
  "page": 1,
  "x": 305.9,
  "y": 540.9,
  "w": 27.5
 },
 "q21a.project": {
  "page": 1,
  "x": 305.9,
  "y": 585.3,
  "w": 27.5
 },
 "q21b.project": {
  "page": 1,
  "x": 305.9,
  "y": 600.7,
  "w": 27.5
 },
 "q21c.project": {
  "page": 1,
  "x": 305.9,
  "y": 616.2,
  "w": 27.5
 },
 "q20a.phase": {
  "page": 1,
  "x": 539.9,
  "y": 438.9,
  "w": 27.4
 },
 "q20b.phase": {
  "page": 1,
  "x": 539.9,
  "y": 454.4,
  "w": 27.4
 },
 "q20c.phase": {
  "page": 1,
  "x": 539.9,
  "y": 485.2,
  "w": 27.4
 },
 "q20d.phase": {
  "page": 1,
  "x": 539.9,
  "y": 512.1,
  "w": 27.4
 },
 "q20e.phase": {
  "page": 1,
  "x": 539.9,
  "y": 540.9,
  "w": 27.4
 },
 "q21a.phase": {
  "page": 1,
  "x": 539.9,
  "y": 585.3,
  "w": 27.4
 },
 "q21b.phase": {
  "page": 1,
  "x": 539.9,
  "y": 600.7,
  "w": 27.4
 },
 "q21c.phase": {
  "page": 1,
  "x": 539.9,
  "y": 616.2,
  "w": 27.4
 },
 "q23.count": {
  "page": 2,
  "x": 469.3,
  "y": 101.9,
  "w": 98.7
 },
 "q25.detail": {
  "page": 2,
  "x": 198.3,
  "y": 148.2,
  "w": 251.9
 },
 "q26m.1to6": {
  "page": 2,
  "x": 113.4,
  "y": 225.4
 },
 "q26m.7plus": {
  "page": 2,
  "x": 221.8,
  "y": 225.4
 },
 "q24.amount": {
  "page": 2,
  "x": 476.3,
  "y": 117.2,
  "w": 88.8
 },
 "sig.name": {
  "page": 2,
  "x": 59.0,
  "y": 641.8,
  "w": 208.2
 },
 "sig.date": {
  "page": 2,
  "x": 383.1,
  "y": 641.8,
  "w": 164.2
 },
 "header.project_legal_name": {
  "page": 0,
  "x": 300,
  "y": 143.1,
  "w": 280
 },
 "header.hoa_tax_id": {
  "page": 0,
  "x": 300,
  "y": 160.1,
  "w": 280
 },
 "header.master_association": {
  "page": 0,
  "x": 300,
  "y": 178.7,
  "w": 280
 },
 "header.property_address": {
  "page": 0,
  "x": 300,
  "y": 220.4,
  "w": 280
 },
 "contact.name": {
  "page": 2,
  "x": 230,
  "y": 423.4,
  "w": 300
 },
 "contact.title": {
  "page": 2,
  "x": 230,
  "y": 441.0,
  "w": 300
 },
 "contact.company": {
  "page": 2,
  "x": 230,
  "y": 459.4,
  "w": 300
 },
 "contact.address": {
  "page": 2,
  "x": 230,
  "y": 477.0,
  "w": 300
 },
 "contact.phone": {
  "page": 2,
  "x": 230,
  "y": 512.0,
  "w": 300
 },
 "contact.email": {
  "page": 2,
  "x": 230,
  "y": 530.4,
  "w": 300
 }
};
